export interface Colorway {
  /**
   * The name of the colorway
   * @example "Black/White"
   */
  colorName: string;

  /**
   * The item number associated with the colorway
   * @example "1MD10480553"
   */
  itemNumber: string;

  /**
   * The launch date of the colorway
   * @example "2024-09-01"
   */
  launchDate: Date | string;

  /**
   * The URL of the image representing the colorway
   * @example "https://example.com/images/black-white.jpg"
   */
  imageUrl: string;

  /**
   * A list of labels associated with the colorway
   * @example ["NEW"]
   */
  labels: ProductLabelEnum[];
}

export interface GenderSpec {
  /**
   * The size range for the gender group
   * @example "40-44"
   */
  sizeRange: string;

  /**
   * The weight of the product in grams
   * @example 260
   */
  weightGrams: number | string;

  /**
   * The heel-toe drop in millimeters
   * @example "6 mm"
   */
  dropMM?: string;
}

export interface CatalogProductPrice {
  /**
   * The wholesale price of the product
   * @example 75
   */
  wholesalePrice?: number | string;

  /**
   * The recommended retail price of the product
   * @example 149.95
   */
  retailerPrice: number | string;

  /**
   * The currency code for the prices
   * @example "EUR"
   */
  currency: string;
}

export interface CatalogGenderGroup {
  /**
   * The name of the gender group
   * @example "Men"
   */
  genderName: string;

  /**
   * The specifications for the gender group
   */
  specs: GenderSpec;

  /**
   * The list of colorways associated with the gender group
   */
  colorways: Colorway[];
}

export interface CatalogProduct {
  /**
   * The name of the product
   * @example "Cloudmonster 2"
   */
  productName: string;

  /**
   * The pricing information for the gender group (omitted for distributors)
   */
  pricing?: CatalogProductPrice;

  /**
   * The list of gender groups associated with the product
   */
  genders: CatalogGenderGroup[];
}

export interface CatalogCategory {
  /**
   * The name of the category
   * @example "Running Shoes"
   */
  categoryName: string;

  /**
   * A list of products associated with the category
   */
  products: CatalogProduct[];
}

export interface Catalog {
  /**
   * The name of the catalog
   * @example "FW26 Catalog"
   */
  catalogName: string;

  /**
   * A list of categories associated with the catalog
   */
  categories: CatalogCategory[];
}

export enum ProductLabelEnum {
  NEW = 'NEW',
}
